<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';
  import { format as formatDate } from 'date-fns';

  import { Icon } from '@client/components/icon';

  import { generateUUID } from '@common/utils/strings';

  const id = `user-roles-${generateUUID()}`;
  const DATE_FORMAT = 'MMM dd, yyyy h:mm:ss a';

  export let data = {};

  $: hasIntegrations =
    data?.sigcompliance?.outreach ||
    data?.sigcompliance?.hubspot ||
    data?.usersettings?.autobcc ||
    data?.sigcompliance?.frontapp ||
    data?.sigcompliance?.salesforce;
</script>

{#if hasIntegrations}
  <div class="integrations">
    {#if data?.sigcompliance?.outreach}
      <i id="{id}-outreach" class="os-icon-outreach" />
      <Tooltip target="{id}-outreach" placement="top">
        <div>{$format('label.OUTREACH_ENABLED')}</div>
        {#if data?.sigcompliance?.outreach}
          <small>{formatDate(new Date(data.sigcompliance.outreach), DATE_FORMAT)}</small>
        {/if}
      </Tooltip>
    {/if}

    {#if data?.sigcompliance?.hubspot}
      <i id="{id}-hubspot" class="os-icon-hubspot" />
      <Tooltip target="{id}-hubspot" placement="top">
        <div>{$format('label.HUBSPOT_ENABLED')}</div>
        <small>{formatDate(new Date(data.sigcompliance.hubspot), DATE_FORMAT)}</small>
      </Tooltip>
    {/if}

    {#if data?.sigcompliance?.frontapp}
      <i id="{id}-frontapp" class="os-icon-front" />
      <Tooltip target="{id}-frontapp" placement="top">
        <div>{$format('label.FRONTAPP_ENABLED')}</div>
        <small>{formatDate(new Date(data.sigcompliance.frontapp), DATE_FORMAT)}</small>
      </Tooltip>
    {/if}

    {#if data?.sigcompliance?.salesforce}
      <i id="{id}-salesforce" class="os-icon-salesforce" />
      <Tooltip target="{id}-salesforce" placement="top">
        <div>{$format('label.SALESFORCE_ENABLED')}</div>
        <small>{formatDate(new Date(data.sigcompliance.salesforce), DATE_FORMAT)}</small>
      </Tooltip>
    {/if}

    {#if data?.usersettings?.autobcc}
      <Icon name="at-sign" id="{id}-autobbc" />
      <Tooltip target="{id}-autobbc" placement="top">
        {data.usersettings.autobcc}
      </Tooltip>
    {/if}
  </div>
{/if}

<style lang="scss" src="./user-integrations.scss"></style>
